<div class="container">
  <div class="row">
    <div class="col-md-8 col-lg-6 mx-auto">
      <div class="form-wrapper">
        <div class="error-message">
          Email not recognised, please try again
        </div>
        <div class="form-group return-login-btn">
          <button class="btn btn-block btn-greengo" (click)="onClick()">Return to log in</button>
        </div>
      </div>
      <div class="footer">
        <p class="p-footer">Don’t have an account?
          <a href="**">Sign up</a>
        </p>
      </div>
    </div>
  </div>
</div>
